import { Controller } from "stimulus"

export default class extends Controller {
  addPair() {
    this.element.querySelector(".comparison-pairs").appendChild(this.element.querySelector("template").content.cloneNode(true))
  }

  programChanged({ target }) {
    const reportSelect = target.closest(".comparison-side").querySelector("select.comparison-report").tomselect

    reportSelect.clear()
    reportSelect.clearOptions()
    reportSelect.addOptions(this.programReports(target.value))
  }

  // Full Culture / Full Leadership reports carry two datasets (Current/Vision, Self/Others) - ask which one to compare
  reportChanged({ target }) {
    const side = target.closest(".comparison-side")
    const datasetSelect = side.querySelector(".comparison-dataset")
    const programId = side.querySelector("select.comparison-program").value
    const datasets = this.programReports(programId).find(report => report.value == target.value)?.datasets || []

    datasetSelect.innerHTML = datasets.map(([value, label]) => `<option value="${value}">${label}</option>`).join("")
    datasetSelect.classList.toggle("d-none", datasets.length < 2)
  }

  programReports(programId) {
    return JSON.parse(this.element.dataset.reports)[programId] || []
  }
}
